<script setup lang="ts">
/**
 * UI-kit component
 * Category: Buttons
 * Name: PrimaryLink
 * Visual twin of BtnPrimary rendered as `<NuxtLink>` (internal) or `<a>` (external)
 * for proper SEO/UX (crawlable href, middle-click, accessibility).
 */
// types
import type { BtnPrimaryLinkProps } from '../types/interfaces'
// hooks
import { useBtnPrimaryLink } from '../composables/use-btn-primary-link.hook'

defineOptions({
  name: 'BtnPrimaryLink',
})

const props = withDefaults(defineProps<BtnPrimaryLinkProps>(), {
  color: 'blue',
  size: 'medium',
  elementWidth: 'auto',
})

const {
  refIsExternal,
  classList,
  refLinkAttrs,
} = useBtnPrimaryLink({ props })
</script>

<template>
  <a
    v-if="refIsExternal"
    :class="classList"
    :href="href"
    v-bind="refLinkAttrs"
  >
    <slot name="iconLeft" />
    <span
      v-if="$slots.default"
      class="ui-btn-primary__text"
    >
      <slot />
    </span>
    <slot name="iconRight" />
  </a>
  <NuxtLink
    v-else
    :class="classList"
    :to="href"
    v-bind="refLinkAttrs"
  >
    <slot name="iconLeft" />
    <span
      v-if="$slots.default"
      class="ui-btn-primary__text"
    >
      <slot />
    </span>
    <slot name="iconRight" />
  </NuxtLink>
</template>

<style lang="scss" scoped src="../styles/_btn-primary.scss" />